/* Store builder product interactions. The form and upsell share the original AJAX cart adapter. */

function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const placeholder = /\{\{\s*(\w+)\s*\}\}/;
  const fmt = format || '${{amount}}';
  const withDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
    if (isNaN(number) || number == null) return '0';
    const fixed = (number / 100).toFixed(precision).split('.');
    const whole = fixed[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (fixed[1] ? decimal + fixed[1] : '');
  };
  const key = (fmt.match(placeholder) || [])[1] || 'amount';
  const table = {
    amount: () => withDelimiters(cents, 2),
    amount_no_decimals: () => withDelimiters(cents, 0),
    amount_with_comma_separator: () => withDelimiters(cents, 2, '.', ','),
    amount_no_decimals_with_comma_separator: () => withDelimiters(cents, 0, '.', ','),
    amount_with_space_separator: () => withDelimiters(cents, 2, ' ', ','),
    amount_no_decimals_with_space_separator: () => withDelimiters(cents, 0, ' ', ','),
    amount_with_apostrophe_separator: () => withDelimiters(cents, 2, "'", '.'),
  };
  const value = (table[key] || table.amount)();
  return fmt.replace(placeholder, value).replace(/<[^>]*>/g, '').trim();
}

const $ = (root, sel) => root.querySelector(sel);
const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));
const readJSON = (el) => {
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
};

/* ---------------- accordions (buy box + FAQ): one open at a time ---------------- */
function initAccordion(list) {
  if (!list || list.dataset.sbReady) return;
  list.dataset.sbReady = '1';
  const buttons = $$(list, '[data-sb-acc]');
  const set = (btn, open) => {
    btn.classList.toggle('sb-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = !open;
  };
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const willOpen = btn.getAttribute('aria-expanded') !== 'true';
      buttons.forEach((b) => set(b, false));
      if (willOpen) set(btn, true);
    });
  });
}

const unlockScroll = () => document.documentElement.classList.remove('sb-noscroll');

/* ---------------- gallery + zoom ---------------- */
function initGallery(root, cfg = {}) {
  const stage = $(root, '[data-sb-stage]');
  if (!stage) return { goToMedia() {}, filter() {} };
  const slides = $$(stage, '[data-sb-slide]');
  const thumbs = $$(root, '[data-sb-thumb]');
  const counters = $$(root, '[data-sb-idx]');
  const totals = $$(root, '[data-sb-total]');
  const navs = $$(root, '.sb-navbtn, .sb-pos, .sb-strip');
  const zoom = $(root, '[data-sb-zoom]');
  const zoomImg = zoom ? $(zoom, '[data-sb-zoom-img]') : null;
  const zoomView = zoom ? $(zoom, '[data-sb-zoom-view]') : null;
  const zoomBig = zoom ? $(zoom, '[data-sb-zoom-big]') : null;
  // order = the slides on show (gallery by colour hides other colours' media); pos = place in that order
  let order = slides.map((_, k) => k).filter((k) => !slides[k].hasAttribute('data-sb-out'));
  if (!order.length) order = slides.map((_, k) => k);
  let pos = 0;
  let current = order[0] || 0;

  const fillZoom = () => {
    if (!zoomImg || !slides[current]) return;
    const full = slides[current].dataset.full;
    const img = $(slides[current], 'img');
    zoomImg.src = full || (img ? img.currentSrc || img.src : '');
    zoomImg.alt = img ? img.alt : '';
  };
  const setBig = (big) => {
    if (!zoomView) return;
    zoomView.classList.toggle('sb-big', big);
    zoomView.classList.toggle('sb-fit', !big);
    if (zoomBig) {
      zoomBig.classList.toggle('sb-on', big);
      zoomBig.setAttribute('aria-pressed', big ? 'true' : 'false');
    }
    if (big) {
      requestAnimationFrame(() => {
        zoomView.scrollLeft = (zoomView.scrollWidth - zoomView.clientWidth) / 2;
        zoomView.scrollTop = (zoomView.scrollHeight - zoomView.clientHeight) / 2;
      });
    }
  };
  const go = (p) => {
    const total = order.length;
    if (!total) return;
    pos = ((p % total) + total) % total;
    current = order[pos];
    slides.forEach((s, k) => {
      s.classList.toggle('sb-on', k === current);
      s.setAttribute('aria-hidden', k === current ? 'false' : 'true');
      if (k === current) {
        const img = $(s, 'img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      }
    });
    thumbs.forEach((t, k) => {
      t.classList.toggle('sb-on', k === current);
      t.setAttribute('aria-pressed', k === current ? 'true' : 'false');
    });
    const li = thumbs[current] && thumbs[current].parentElement;
    const list = li && li.parentElement;
    if (list) {
      const left = li.offsetLeft - list.offsetLeft;
      if (left < list.scrollLeft || left + li.offsetWidth > list.scrollLeft + list.clientWidth) {
        list.scrollTo({ left: Math.max(0, left - 4), behavior: 'smooth' });
      }
    }
    counters.forEach((c) => { c.textContent = String(pos + 1); });
    if (zoom && zoom.open) fillZoom();
  };
  const relabel = () => {
    const total = order.length;
    totals.forEach((t) => { t.textContent = String(total); });
    navs.forEach((n) => { n.hidden = total < 2; });
    if (!cfg.imageNofM) return;
    order.forEach((k, p) => {
      const t = thumbs[k];
      if (t) t.setAttribute('aria-label', cfg.imageNofM.replace('[n]', p + 1).replace('[m]', total) + (t.dataset.labelTail || ''));
    });
  };
  const openZoom = () => {
    if (!zoom || typeof zoom.showModal !== 'function') return;
    fillZoom();
    setBig(false);
    if (!zoom.open) zoom.showModal();
    document.documentElement.classList.add('sb-noscroll');
  };
  const closeZoom = () => { if (zoom && zoom.open) zoom.close(); unlockScroll(); };

  $$(root, '[data-sb-prev]').forEach((b) => b.addEventListener('click', () => go(pos - 1)));
  $$(root, '[data-sb-next]').forEach((b) => b.addEventListener('click', () => go(pos + 1)));
  thumbs.forEach((t, k) => t.addEventListener('click', () => { const p = order.indexOf(k); if (p >= 0) go(p); }));
  $$(root, '[data-sb-zoom-open]').forEach((b) => b.addEventListener('click', openZoom));

  stage.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(pos - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(pos + 1); }
    else if ((e.key === 'Enter' || e.key === ' ') && e.target === stage) { e.preventDefault(); openZoom(); }
  });
  let tx = null;
  stage.addEventListener('touchstart', (e) => { tx = e.touches && e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
  stage.addEventListener('touchend', (e) => {
    const t = e.changedTouches && e.changedTouches[0];
    if (!t || tx === null) return;
    const d = t.clientX - tx;
    if (d > 40) go(pos - 1); else if (d < -40) go(pos + 1);
    tx = null;
  });

  if (zoom) {
    $$(zoom, '[data-sb-zoom-close]').forEach((b) => b.addEventListener('click', closeZoom));
    if (zoomBig) zoomBig.addEventListener('click', () => setBig(!zoomView.classList.contains('sb-big')));
    if (zoomImg) zoomImg.addEventListener('click', () => setBig(!zoomView.classList.contains('sb-big')));
    zoom.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(pos - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(pos + 1); }
    });
    zoom.addEventListener('cancel', unlockScroll);
    zoom.addEventListener('close', () => { unlockScroll(); setBig(false); });
  }

  go(0);
  relabel();
  return {
    goToMedia(id) {
      if (!id) return;
      const p = order.indexOf(slides.findIndex((s) => s.dataset.mediaId === String(id)));
      if (p >= 0) go(p);
    },
    // show untagged media + media tagged with this value (alt text ending in "[White]")
    filter(value) {
      const v = String(value || '').toLowerCase().trim();
      slides.forEach((s, k) => {
        const tags = (s.dataset.sbTag || '').split(',').map((t) => t.trim()).filter(Boolean);
        const out = !!v && tags.length > 0 && !tags.includes(v);
        s.toggleAttribute('data-sb-out', out);
        const li = thumbs[k] && thumbs[k].parentElement;
        if (li) li.hidden = out;
      });
      order = slides.map((_, k) => k).filter((k) => !slides[k].hasAttribute('data-sb-out'));
      const keep = order.indexOf(current);
      relabel();
      go(keep >= 0 ? keep : 0);
    },
  };
}

/* ---------------- fit pop-up ---------------- */
function initFit(root) {
  const dlg = $(root, '[data-sb-fit]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  const open = () => { if (!dlg.open) dlg.showModal(); document.documentElement.classList.add('sb-noscroll'); };
  const close = () => { if (dlg.open) dlg.close(); unlockScroll(); };
  $$(root, '[data-sb-fit-open]').forEach((b) => b.addEventListener('click', open));
  $$(dlg, '[data-sb-fit-close]').forEach((b) => b.addEventListener('click', close));
  const shade = $(dlg, '[data-sb-fit-shade]');
  if (shade) shade.addEventListener('click', (e) => { if (e.target === shade) close(); });
  dlg.addEventListener('cancel', unlockScroll);
  dlg.addEventListener('close', unlockScroll);
}

/* ---------------- variants, add to cart, sticky bar ---------------- */
// Quantity ladder, same rules as snippets/sb-qty-off.liquid: "2:14.99, 3:34.98" (amount off) or "2:15%, 3:23%".
function qtyOff(ladder, units, subtotal, prices) {
  let best = null;
  String(ladder || '').split(',').forEach((step) => {
    const [n, v] = step.split(':');
    const q = parseInt(n, 10);
    if (q > 0 && q <= units && v && v.trim() && (!best || q >= best.q)) best = { q, v: v.trim() };
  });
  if (!best) return 0;
  // Percentages floor to the cent PER UNIT like Shopify (2 x 29.95 at 10% = 5.98 off): pass the unit prices; fixed amounts
  // are in shop currency, so convert at the presentment rate.
  const rate = Number(window.Shopify?.currency?.rate) || 1;
  const pct = parseFloat(best.v);
  const floorPct = (c) => Math.floor((c * pct) / 100 + 1e-8);
  const off = best.v.includes('%')
    ? (Array.isArray(prices) && prices.length ? prices.reduce((t, c) => t + floorPct(c), 0) : floorPct(subtotal))
    : Math.round(parseFloat(best.v) * 100 * rate);
  return Math.min(Math.max(off || 0, 0), subtotal);
}

function initBuy(root, gallery) {
  const variants = readJSON($(root, '[data-sb-variants]')) || [];
  const cfg = readJSON($(root, '[data-sb-config]')) || {};
  const idInput = $(root, '[data-sb-variant-id]');
  const qtyInput = $(root, '[data-sb-qty-input]');
  const addBtn = $(root, '[data-sb-add]');
  const addLabel = $(root, '[data-sb-add-label]');
  const status = $(root, '[data-sb-status]');
  const bar = $(root, '[data-sb-sab]');
  const barSelect = bar ? $(bar, '[data-sb-sab-select]') : null;
  const barBtn = bar ? $(bar, '[data-sb-sab-add]') : null;
  const barSm = bar ? $(bar, '[data-sb-sab-sm]') : null;
  const barLg = bar ? $(bar, '[data-sb-sab-lg]') : null;
  const barPrice = bar ? $(bar, '[data-sb-sab-price]') : null;
  const barCompare = bar ? $(bar, '[data-sb-sab-compare]') : null;
  const barVariant = bar ? $(bar, '[data-sb-sab-variant]') : null;
  const barStatus = bar ? $(bar, '[data-sb-sab-status]') : null;
  const scrollMode = !!(barBtn && barBtn.hasAttribute('data-sb-sab-scroll'));
  const bundleIndex = parseInt(root.dataset.bundleIndex, 10);
  const hasBundle = !isNaN(bundleIndex) && bundleIndex >= 0;
  // quantity mode: tier cards set the quantity, each unit picks its own value of EVERY option in unitOpts (Colour + Size)
  const qtyMode = !!cfg.qtyMode;
  const unitIndex = typeof cfg.unitIndex === 'number' ? cfg.unitIndex : -1;
  const unitOpts = Array.isArray(cfg.unitOpts) && cfg.unitOpts.length ? cfg.unitOpts.map(Number) : (unitIndex >= 0 ? [unitIndex] : []);
  // the option the gallery filters by: the colour option, never a size (sb-main.liquid "Option roles")
  const galleryIndex = typeof cfg.galleryIndex === 'number' ? cfg.galleryIndex : unitIndex;
  const qtyGroup = qtyMode ? $(root, '[data-sb-qty-group]') : null;
  const unitRows = qtyMode ? $$(root, '[data-sb-unit]') : [];
  const unitsBox = qtyMode ? $(root, '[data-sb-units]') : null;
  const unitsNote = unitsBox ? $(unitsBox, '[data-sb-units-note]') : null;
  const unitName = unitsBox ? $(unitsBox, '[data-sb-unit-name]') : null;
  // option rows that are not per unit: every row in variant/single mode (tier cards included), one-value rows in quantity mode
  const groups = $$(root, '[data-sb-opt-index]').filter((g) => !g.hasAttribute('data-sb-unit'));
  // the tier radios only (per-unit choices can sit inside the selected card, units_place "in_tier")
  const tierRadios = () => (qtyGroup ? $$(qtyGroup, '.sb-tiers > li > input[type="radio"]') : []);
  const unitsInTier = !!(unitsBox && unitsBox.classList.contains('sb-units--in'));
  const money = (c) => formatMoney(c, cfg.moneyFormat);
  const addText = cfg.addLabel || 'Add to cart';
  const soldText = cfg.soldOut || 'Sold out';
  if (!idInput || !variants.length) return;

  // a control = one option's picker: a <select>, or a row / list holding radios (swatches, pills, tier cards)
  const ctlVal = (c) => {
    if (!c) return null;
    const sel = c.tagName === 'SELECT' ? c : $(c, 'select');
    if (sel) return sel.value;
    const k = $(c, 'input[type="radio"]:checked');
    return k ? k.value : null;
  };
  const ctlSet = (c, value) => {
    if (!c) return;
    const sel = c.tagName === 'SELECT' ? c : $(c, 'select');
    if (sel) { if (Array.from(sel.options).some((o) => o.value === value)) sel.value = value; return; }
    const next = $$(c, 'input[type="radio"]').find((i) => i.value === value);
    if (next) next.checked = true;
  };
  const rowOf = (u) => unitRows.find((r) => r.dataset.sbUnit === String(u)) || null;
  // unit u's control for option i (grid: one select per option; one-option rows: the row's select or swatch list)
  const ctlOf = (u, i) => {
    const r = rowOf(u);
    if (!r) return null;
    return $(r, `[data-sb-uopt="${i}"]`) || (unitOpts.length === 1 && i === unitOpts[0] ? r : null);
  };
  const selected = () => {
    const out = [];
    groups.forEach((g) => { out[parseInt(g.dataset.sbOptIndex, 10)] = ctlVal(g); });
    if (qtyMode) unitOpts.forEach((i) => { const v = ctlVal(ctlOf(1, i)); if (v != null) out[i] = v; });
    return out;
  };
  const find = (opts) => variants.find((v) => opts.every((o, j) => o == null || v.options[j] === o)) || null;
  const selQty = () => {
    const c = tierRadios().find((i) => i.checked);
    return c ? parseInt(c.value, 10) || 1 : 1;
  };
  // unit u's options: the shared ones from opts, its own picks for unitOpts
  const unitVec = (opts, u) => {
    const o = opts.slice();
    unitOpts.forEach((i) => { const v = ctlVal(ctlOf(u, i)); if (v != null) o[i] = v; });
    return o;
  };
  const unitVariants = (opts, qty) => {
    const out = [];
    for (let u = 1; u <= qty; u += 1) out.push(find(unitVec(opts, u)));
    return out;
  };
  // cart lines for the units: one line per variant, in unit order
  const linesFor = (units) => {
    const map = new Map();
    units.forEach((v) => { if (v) map.set(v.id, (map.get(v.id) || 0) + 1); });
    return Array.from(map, ([id, quantity]) => ({ id, quantity }));
  };
  const priceOf = (units) => units.reduce((t, v) => t + (v ? v.price : 0), 0);
  const fullOf = (units) => units.reduce((t, v) => t + (v ? (v.compare_at_price > v.price ? v.compare_at_price : v.price) : 0), 0);
  const anyAvail = (i, val) => variants.some((v) => v.available && v.options[i] === val);
  // the combination with option i set to val: '' available, 'sold' exists but sold out, 'na' doesn't exist
  const stateOf = (o, i, val) => { const x = o.slice(); x[i] = val; const v = find(x); return v ? (v.available ? '' : 'sold') : 'na'; };
  // Picking a value whose combination is sold out or doesn't exist (XL only in Black) moves the OTHER options to the
  // closest available combination; the option just picked stays. Closest = keeps the tier, then the earlier options.
  const weight = (j) => (j === bundleIndex ? 4096 : 2 ** Math.max(0, 10 - j));
  const closest = (o, keep) => {
    const cur = find(o);
    if (cur && cur.available) return null;
    let best = null; let score = -1;
    variants.forEach((v) => {
      if (!v.available || v.options[keep] !== o[keep]) return;
      let s = 0;
      v.options.forEach((x, j) => { if (j !== keep && x === o[j]) s += weight(j); });
      if (s > score) { score = s; best = v; }
    });
    return best;
  };
  const fixUnit = (u, keep) => {
    const o = unitVec(selected(), u);
    const b = closest(o, keep);
    if (b) unitOpts.forEach((j) => { if (j !== keep && b.options[j] !== o[j]) ctlSet(ctlOf(u, j), b.options[j]); });
  };
  const fixGlobal = (keep) => {
    const o = selected();
    const b = closest(o, keep);
    if (b) groups.forEach((g) => { const j = parseInt(g.dataset.sbOptIndex, 10); if (j !== keep && b.options[j] !== o[j]) ctlSet(g, b.options[j]); });
  };
  const soldTpl = cfg.optSoldOut || '[value] (sold out)';
  const naTpl = cfg.optUnavailable || '[value] (unavailable)';
  // mark every value of a control for the combination o: dropdown text "(sold out)" / "(unavailable)", swatch/pill
  // .sb-na + screen-reader suffix; a value no available variant has is disabled
  const paint = (c, o, i) => {
    if (!c) return;
    const sel = c.tagName === 'SELECT' ? c : $(c, 'select');
    if (sel) {
      Array.from(sel.options).forEach((op) => {
        const val = op.value;
        const off = !anyAvail(i, val);
        const st = off ? 'sold' : stateOf(o, i, val);
        const text = st === 'na' ? naTpl.replace('[value]', val) : st ? soldTpl.replace('[value]', val) : val;
        if (op.textContent !== text) op.textContent = text;
        if (op.disabled !== off) op.disabled = off;
      });
      return;
    }
    $$(c, 'input[type="radio"]').forEach((inp) => {
      const val = inp.value;
      const off = !anyAvail(i, val);
      const st = off ? 'off' : stateOf(o, i, val);
      if (inp.disabled !== off) inp.disabled = off;
      const l = inp.id ? root.querySelector(`label[for="${CSS.escape(inp.id)}"]`) : null;
      if (!l || l.hasAttribute('data-sb-tier')) return;
      l.classList.toggle('sb-na', !!st);
      if (st) l.dataset.state = st; else delete l.dataset.state;
      const sr = $(l, '[data-sb-state]');
      if (sr) sr.textContent = st === 'na' ? cfg.srUnavailable || '' : st ? cfg.srSoldOut || '' : '';
    });
  };
  // the page scroller: Horizon's .page-wrapper from 990 px, else the window
  const nudge = (dy) => {
    const pw = document.querySelector('.page-wrapper');
    const oy = pw ? getComputedStyle(pw).overflowY : '';
    if (pw && pw.scrollHeight > pw.clientHeight + 1 && (oy === 'auto' || oy === 'scroll')) pw.scrollTop += dy;
    else window.scrollBy(0, dy);
  };
  let currentVariant = null;
  let currentUnits = [];
  let extraLines = [];
  let galleryValue = null;

  const apply = (pushUrl) => {
    const opts = selected();
    const v = find(opts);
    currentVariant = v;
    const qty = qtyMode ? selQty() : 1;

    groups.concat(unitRows).forEach((g) => {
      const checked = $(g, 'input[type="radio"]:checked');
      $$(g, 'label').forEach((l) => { if (!l.hasAttribute('data-sb-tier') || !qtyGroup) l.classList.toggle('sb-on', !!checked && l.htmlFor === checked.id); });
      const valueEl = $(g, '[data-sb-opt-value]');
      if (valueEl && checked) valueEl.textContent = checked.value;
      $$(g, 'select').forEach((sel) => {
        const box = sel.closest('.sb-usel');
        const dot = box ? $(box, '[data-sb-dot]') : null;
        if (dot && sel.selectedOptions[0]) dot.style.background = sel.selectedOptions[0].dataset.sw || '';
      });
    });
    if (qtyGroup) {
      const checked = tierRadios().find((i) => i.checked);
      $$(qtyGroup, 'label[data-sb-tier]').forEach((l) => l.classList.toggle('sb-on', !!checked && l.htmlFor === checked.id));
      // in-tier choices follow the picked card; the picked card stays where the finger is (the panel leaving a card
      // above it would pull it up by the panel's height)
      if (unitsInTier && checked && checked.parentElement && unitsBox.parentElement !== checked.parentElement) {
        const lab = $(checked.parentElement, 'label[data-sb-tier]');
        const y0 = lab ? lab.getBoundingClientRect().top : 0;
        checked.parentElement.appendChild(unitsBox);
        if (pushUrl && lab) {
          const dy = lab.getBoundingClientRect().top - y0;
          if (Math.abs(dy) > 0.5) nudge(dy);
        }
      }
    }

    if (hasBundle) {
      $$(root, '[data-sb-tier]').forEach((tier) => {
        const o = opts.slice();
        o[bundleIndex] = tier.dataset.value;
        const tv = find(o);
        const p = $(tier, '[data-sb-tier-price]');
        const c = $(tier, '[data-sb-tier-compare]');
        const inp = tier.htmlFor ? document.getElementById(tier.htmlFor) : null;
        if (inp) inp.disabled = !anyAvail(bundleIndex, tier.dataset.value);
        if (!tv) { if (p) p.textContent = cfg.unavailable || 'Unavailable'; if (c) c.hidden = true; tier.dataset.soldout = 'true'; return; }
        if (p) p.textContent = money(tv.price);
        if (c) {
          const show = cfg.showCompare && tv.compare_at_price && tv.compare_at_price > tv.price;
          c.hidden = !show;
          if (show) c.textContent = money(tv.compare_at_price);
        }
        if (tv.available) delete tier.dataset.soldout; else tier.dataset.soldout = 'true';
      });
    }

    let units = [v];
    let total = v ? v.price : 0;
    let full = v ? fullOf([v]) : 0;
    if (qtyMode) {
      // per-unit rows: units 1..qty show, the rest stay hidden (they keep their picks)
      unitRows.forEach((r) => { const u = parseInt(r.dataset.sbUnit, 10); if (u > 1) r.hidden = u > qty; });
      if (unitsBox) unitsBox.classList.toggle('sb-multi', qty > 1);
      if (unitsNote) unitsNote.hidden = qty < 2;
      if (unitName) unitName.textContent = qty > 1 ? unitName.dataset.many : unitName.dataset.one;
      units = unitVariants(opts, qty);
      // each card: its quantity at the units' prices (extra units priced like unit 1), less the ladder
      $$(root, '[data-sb-tier]').forEach((tier) => {
        const q = parseInt(tier.dataset.value, 10) || 1;
        const tu = [];
        for (let i = 0; i < q; i += 1) tu.push(units[i] || units[0] || v);
        const sub = priceOf(tu);
        const t = sub - qtyOff(cfg.qtyOffers, q, sub, tu.map((x) => (x ? x.price : 0)));
        const f = fullOf(tu);
        const p = $(tier, '[data-sb-tier-price]');
        const c = $(tier, '[data-sb-tier-compare]');
        if (p) p.textContent = money(t);
        if (c) { const show = cfg.showCompare && f > t; c.hidden = !show; if (show) c.textContent = money(f); }
        const subEl = $(tier, '[data-sb-sub-tpl]');
        if (subEl) {
          const txt = subEl.dataset.sbSubTpl.replace(/\[each\]/g, money(Math.round(t / q))).replace(/\[save\]/g, money(Math.max(f - t, 0)));
          subEl.innerHTML = '';
          txt.split(' · ').forEach((part, i) => {
            if (i) { const sep = document.createElement('span'); sep.className = 'sb-s__sep'; sep.setAttribute('aria-hidden', 'true'); sep.textContent = ' · '; subEl.appendChild(sep); }
            subEl.appendChild(document.createTextNode(part));
          });
        }
        const ok = tu.every((x) => x && x.available);
        if (ok) delete tier.dataset.soldout; else tier.dataset.soldout = 'true';
      });
      const sub = priceOf(units);
      total = sub - qtyOff(cfg.qtyOffers, qty, sub, units.map((x) => (x ? x.price : 0)));
      full = fullOf(units);
      for (let u = 1; u <= unitRows.length; u += 1) {
        if (!rowOf(u)) continue;
        const o = unitVec(opts, u);
        unitOpts.forEach((i) => paint(ctlOf(u, i), o, i));
      }
    }
    groups.forEach((g) => { const i = parseInt(g.dataset.sbOptIndex, 10); if (i !== bundleIndex) paint(g, opts, i); });
    currentUnits = units;

    // accordion bodies written per tier (e.g. what's in the box): show the selected tier's, else the default
    if (hasBundle || qtyMode) {
      const tiers = $$(root, '[data-sb-tier]');
      const want = qtyMode ? String(qty) : opts[bundleIndex];
      const n = String(tiers.findIndex((t) => t.dataset.value === want) + 1);
      $$(root, '.sb-acc .sb-a').forEach((panel) => {
        const bodies = $$(panel, '[data-sb-tierbody]');
        if (!bodies.length) return;
        const match = bodies.find((b) => b.dataset.sbTierbody === n);
        bodies.forEach((b) => { b.hidden = match ? b !== match : b.dataset.sbTierbody !== 'default'; });
      });
    }

    if (!v || units.some((x) => !x)) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = cfg.unavailable || 'Unavailable';
      if (barBtn && !scrollMode) barBtn.disabled = true;
      if (barSm) barSm.textContent = cfg.unavailable || 'Unavailable';
      return;
    }
    // first line goes through Horizon's form (id + quantity); any other variants are added just before it
    const lines = linesFor(units);
    idInput.value = String(lines[0].id);
    if (qtyInput) qtyInput.value = String(qtyMode ? lines[0].quantity : 1);
    extraLines = qtyMode ? lines.slice(1) : [];
    const available = units.every((x) => x.available);
    const price = money(total);
    const hasCompare = qtyMode ? cfg.showCompare && full > total : cfg.showCompare && v.compare_at_price && v.compare_at_price > v.price;
    if (addBtn) addBtn.disabled = !available;
    if (addLabel) addLabel.textContent = available ? `${addText} · ${price}` : soldText;
    if (barBtn && !scrollMode) barBtn.disabled = !available;
    if (barSm) barSm.textContent = available ? `${addText} · ${price}` : soldText;
    if (barLg) barLg.textContent = available ? addText : soldText;
    if (barPrice) barPrice.textContent = price;
    if (barCompare) { barCompare.hidden = !hasCompare; if (hasCompare) barCompare.textContent = money(qtyMode ? full : v.compare_at_price); }
    if (barVariant) {
      // quantity mode: each distinct unit pick once ("Black / M, Navy / L"), then the shared one-value options
      const others = qtyMode && unitOpts.length
        ? [Array.from(new Set(units.map((x) => unitOpts.map((i) => x.options[i]).join(' / ')))).join(', ')].concat(v.options.filter((o, j) => !unitOpts.includes(j)))
        : v.options.filter((o, j) => j !== bundleIndex);
      barVariant.textContent = [others.join(' / '), cfg.sizeNote].filter(Boolean).join(' · ');
    }
    if (barSelect && hasBundle) barSelect.value = v.options[bundleIndex];
    if (barSelect && qtyMode) barSelect.value = String(qty);
    // gallery: quantity mode = the colour last picked on a unit that is still shown, else unit 1's; otherwise the variant's
    let gv = v;
    if (galleryIndex >= 0) {
      let gval = v.options[galleryIndex];
      if (qtyMode && galleryValue != null && units.some((x) => x.options[galleryIndex] === galleryValue)) gval = galleryValue;
      if (gval !== v.options[galleryIndex]) gv = units.find((x) => x.options[galleryIndex] === gval) || v;
      if (gallery && cfg.galleryFilter) gallery.filter(gval);
    }
    if (gallery && pushUrl) {
      const fm = (gv || v).featured_media;
      if (fm && fm.id) gallery.goToMedia(fm.id);
    }
    if (status) status.textContent = '';
    if (pushUrl && window.history && window.history.replaceState) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(v.id));
        if (qtyMode) url.searchParams.set('qty', String(qty));
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* ignore */ }
    }
  };

  // one delegated listener: tier radios, per-unit pickers, option rows (the sticky bar's select has its own)
  root.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.matches || !t.matches('input[type="radio"], select')) return;
    if (bar && bar.contains(t)) return;
    if (qtyGroup && tierRadios().includes(t)) { apply(true); return; }
    const urow = qtyMode ? t.closest('[data-sb-unit]') : null;
    if (urow && unitRows.includes(urow)) {
      const u = parseInt(urow.dataset.sbUnit, 10);
      const c = t.closest('[data-sb-uopt]');
      const i = c ? parseInt(c.dataset.sbUopt, 10) : unitOpts[0];
      const gHas = unitOpts.includes(galleryIndex);
      const gBefore = gHas ? ctlVal(ctlOf(u, galleryIndex)) : null;
      // one-option swatch rows under the cards: a new unit-1 value carries to the units still on the old one
      // (the dropdowns are independent, one per piece, like Kaching)
      if (!unitsInTier && unitOpts.length === 1 && u === 1 && urow.dataset.sbPrev) {
        unitRows.forEach((r) => { if (r !== urow) { const rc = ctlOf(parseInt(r.dataset.sbUnit, 10), i); if (ctlVal(rc) === urow.dataset.sbPrev) ctlSet(rc, t.value); } });
      }
      if (u === 1) urow.dataset.sbPrev = t.value;
      fixUnit(u, i);
      if (gHas) { const g = ctlVal(ctlOf(u, galleryIndex)); if (i === galleryIndex || g !== gBefore) galleryValue = g; }
      apply(true);
      return;
    }
    const g = t.closest('[data-sb-opt-index]');
    if (g && groups.includes(g)) {
      if (!qtyMode) fixGlobal(parseInt(g.dataset.sbOptIndex, 10));
      apply(true);
    }
  });
  // A sold-out ?variant= shows as sold out on unit 1 (the URL named it), but the extra units never start on a sold-out or
  // missing combination: they take the closest available variant (same colour where possible)
  if (qtyMode && unitOpts.length) {
    const base = selected();
    for (let u = 2; u <= unitRows.length; u += 1) {
      if (!rowOf(u)) continue;
      const o = unitVec(base, u);
      const cur = find(o);
      if (cur && cur.available) continue;
      const keep = unitOpts.includes(galleryIndex) ? galleryIndex : unitOpts[0];
      const b = closest(o, keep) || variants.find((v) => v.available);
      if (b) unitOpts.forEach((j) => ctlSet(ctlOf(u, j), b.options[j]));
    }
  }
  const firstUnit = rowOf(1);
  if (firstUnit && unitOpts.length) { const fv = ctlVal(ctlOf(1, unitOpts[0])); if (fv) firstUnit.dataset.sbPrev = fv; }

  // ?qty=2 (home bundle cards) picks that tier
  if (qtyGroup) {
    try {
      const want = new URL(window.location.href).searchParams.get('qty');
      const input = want ? tierRadios().find((i) => i.value === want) : null;
      if (input) input.checked = true;
    } catch (e) { /* ignore */ }
  }

  // Submit every selected unit in one AJAX request, including mixed variants.
  const form = idInput.form;
  if (form) form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (form.dataset.sbBusy || addBtn.disabled) return;
    form.dataset.sbBusy = '1';
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');
    try {
      const items = [{ id: Number(idInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) }, ...extraLines];
      if (!window.SBCart) throw new Error(cfg.addError || 'Cart is still loading. Please try again.');
      await window.SBCart.add(items);
      addBtn.dataset.added = 'true';
      setTimeout(() => { delete addBtn.dataset.added; }, 2500);
    } catch (err) {
      if (status) status.textContent = err.message || cfg.addError || '';
      if (barStatus) barStatus.textContent = err.message || cfg.addError || '';
    } finally {
      delete form.dataset.sbBusy;
      addBtn.classList.remove('is-loading');
      apply(false);
    }
  });

  // The form sets an accessible confirmation after the drawer refresh.
  if (addBtn && 'MutationObserver' in window) {
    new MutationObserver(() => {
      const added = addBtn.dataset.added === 'true';
      if (added && currentVariant) {
        let item;
        if (qtyMode) {
          const tier = $$(root, '[data-sb-tier]').find((t) => t.dataset.value === String(selQty()));
          const name = tier && $(tier, '.sb-t') ? $(tier, '.sb-t').textContent.trim() : `${currentUnits.length} ×`;
          const cols = unitOpts.length ? Array.from(new Set(currentUnits.filter(Boolean).map((x) => unitOpts.map((i) => x.options[i]).join(' / ')))).join(', ') : '';
          item = `${name}${cols ? ` (${cols})` : ''}`;
        } else {
          const bundle = hasBundle ? currentVariant.options[bundleIndex] : currentVariant.title;
          const others = currentVariant.options.filter((o, j) => j !== bundleIndex).join(' / ');
          item = `${bundle}${others ? ` (${others})` : ''}`;
        }
        const msg = (cfg.addedMsg || 'Added [item] to your cart.').replace(/\[item\]/, item);
        if (status) status.textContent = msg;
        if (barStatus) barStatus.textContent = msg;
      }
      if (bar) bar.classList.toggle('sb-added', added);
      if (barSm && added) barSm.textContent = cfg.addedLabel || 'Added to cart';
      if (barLg && added) barLg.textContent = cfg.addedLabel || 'Added to cart';
      if (!added) apply(false);
    }).observe(addBtn, { attributes: true, attributeFilter: ['data-added'] });
  }

  if (barSelect) {
    barSelect.addEventListener('change', () => {
      const g = qtyMode ? qtyGroup : groups.find((x) => parseInt(x.dataset.sbOptIndex, 10) === bundleIndex);
      if (!g) return;
      const input = (qtyMode ? tierRadios() : $$(g, 'input[type="radio"]')).find((i) => i.value === barSelect.value);
      if (input) {
        input.checked = true;
        if (!qtyMode) fixGlobal(bundleIndex);
        apply(true);
      }
    });
  }
  if (barBtn && addBtn && !scrollMode) {
    barBtn.addEventListener('click', () => { if (!addBtn.disabled) addBtn.click(); });
  }
  // scroll mode: bring the option picker (tier cards first) into view and focus the selected choice
  if (barBtn && scrollMode) {
    barBtn.addEventListener('click', () => {
      const tierGroup = qtyGroup || (hasBundle ? groups.find((x) => parseInt(x.dataset.sbOptIndex, 10) === bundleIndex) : null);
      const group = tierGroup || groups.find((x) => !x.hidden) || null;
      const target = group || addBtn;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
      const radios = group === qtyGroup ? tierRadios() : (group ? $$(group, 'input[type="radio"]') : []);
      const focusEl = group ? (radios.find((i) => i.checked) || radios.find((i) => !i.disabled)) : addBtn;
      if (focusEl) {
        try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); }
      }
      if (group) {
        group.classList.remove('sb-pulse');
        void group.offsetWidth;
        group.classList.add('sb-pulse');
        setTimeout(() => group.classList.remove('sb-pulse'), 1600);
      }
    });
  }

  // show the bar once the main button has scrolled up out of view
  if (bar && addBtn) {
    let raf = 0;
    const check = () => {
      raf = 0;
      const r = addBtn.getBoundingClientRect();
      const header = document.querySelector('header-component');
      const top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const show = r.height > 0 && r.bottom < top;
      bar.classList.toggle('sb-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
      // keep the bar clear of the page scrollbar when .page-wrapper is the scroller
      const pw = document.querySelector('.page-wrapper');
      const gap = pw && pw.scrollHeight > pw.clientHeight && getComputedStyle(pw).overflowY !== 'visible' ? pw.offsetWidth - pw.clientWidth : 0;
      bar.style.right = gap > 0 ? gap + 'px' : '';
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(check); };
    // capture catches scrolls on Horizon's .page-wrapper (desktop) as well as the document (mobile)
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    check();
  }

  apply(false);
}

/* ---------------- delivery estimate: business days from today, in the visitor's locale ---------------- */
function addBusinessDays(from, days) {
  const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  let left = days;
  while (left > 0) {
    d.setDate(d.getDate() + 1);
    const wd = d.getDay();
    if (wd !== 0 && wd !== 6) left -= 1;
  }
  // an order placed at the weekend with 0 days still can't arrive on a weekend
  while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
  return d;
}
function initDelivery(el) {
  if (!el || el.dataset.sbReady) return;
  el.dataset.sbReady = '1';
  let min = parseInt(el.dataset.min, 10) || 0;
  let max = parseInt(el.dataset.max, 10) || 0;
  if (!min && !max) return;
  if (!min) min = max;
  if (!max) max = min;
  if (min > max) [min, max] = [max, min];
  const out = $(el, '[data-sb-delivery-text]');
  if (!out) return;
  let fmt;
  try { fmt = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' }); } catch (e) { fmt = null; }
  const f = (d) => (fmt ? fmt.format(d) : d.toDateString());
  const now = new Date();
  const a = f(addBusinessDays(now, min));
  const b = f(addBusinessDays(now, max));
  const pattern = el.dataset.pattern || '[start]–[end]';
  let text;
  if (a === b) {
    text = el.dataset.patternSingle
      ? el.dataset.patternSingle.replace(/\[date\]/g, a)
      : pattern.replace(/\[start\]\s*[–—-]\s*\[end\]/g, a).replace(/\[start\]|\[end\]/g, a);
  } else {
    text = pattern.replace(/\[start\]/g, a).replace(/\[end\]/g, b);
  }
  out.textContent = text;
  el.hidden = false;
}

/* ---------------- reviews: numbered pages ---------------- */
// sb-reviews.liquid prints every card plus hidden page controls; this shows one page at a time (per_page from the
// section), wires Previous/Next/numbers (native buttons, so Enter/Space work), moves focus to the grid on a page change,
// keeps 1, last and current±1 visible with gaps, and opens the right page when the editor selects a review block.
function initReviews(root) {
  const grid = $(root, '[data-sb-rev-grid]');
  const controls = $(root, '[data-sb-rev-controls]');
  if (!grid || !controls || root.dataset.sbReviewsReady) return;
  const cards = $$(grid, '.sb-revcard');
  const perPage = Math.min(12, Math.max(3, Number(root.dataset.sbReviewsPerPage) || 6));
  const totalPages = Math.ceil(cards.length / perPage);
  if (totalPages < 2) return;
  root.dataset.sbReviewsReady = '1';
  const previous = $(controls, '[data-sb-rev-prev]');
  const next = $(controls, '[data-sb-rev-next]');
  const numbers = $$(controls, '[data-sb-rev-page]');
  const gaps = $$(controls, '[data-sb-rev-gap]');
  const status = $(controls, '[data-sb-rev-status]');
  let current = 1;
  const showPage = (requested, moveFocus = false) => {
    current = Math.min(totalPages, Math.max(1, requested));
    const start = (current - 1) * perPage;
    cards.forEach((card, index) => { card.hidden = index < start || index >= start + perPage; });
    if (previous) previous.disabled = current === 1;
    if (next) next.disabled = current === totalPages;
    const visiblePages = numbers.map((button) => Number(button.dataset.sbRevPage))
      .filter((page) => totalPages <= 5 || page === 1 || page === totalPages || Math.abs(page - current) <= 1);
    numbers.forEach((button) => {
      const page = Number(button.dataset.sbRevPage);
      button.hidden = !visiblePages.includes(page);
      if (page === current) button.setAttribute('aria-current', 'page');
      else button.removeAttribute('aria-current');
    });
    gaps.forEach((gap) => {
      const page = Number(gap.dataset.sbRevGap);
      const index = visiblePages.indexOf(page);
      gap.hidden = index <= 0 || page - visiblePages[index - 1] <= 1;
    });
    if (status && status.dataset.pattern) status.textContent = status.dataset.pattern.replace('[page]', current).replace('[pages]', totalPages);
    controls.hidden = false;
    if (moveFocus) {
      grid.focus({ preventScroll: true });
      grid.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
  };
  controls.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    if (!button || !controls.contains(button) || button.disabled) return;
    const page = button === previous ? current - 1 : button === next ? current + 1 : Number(button.dataset.sbRevPage);
    if (Number.isInteger(page) && page !== current) showPage(page, true);
  });
  root.addEventListener('shopify:block:select', (event) => {
    const index = cards.indexOf(event.target.closest('.sb-revcard'));
    if (index >= 0) showPage(Math.floor(index / perPage) + 1);
  });
  showPage(1);
}

/* ---------------- photo slider: load every card before it scrolls into view ---------------- */
function initUgc(track) {
  if (track.dataset.sbReady) return;
  track.dataset.sbReady = '1';
  const load = () => $$(track, 'img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
  if (!('IntersectionObserver' in window)) { load(); return; }
  const pw = document.querySelector('.page-wrapper');
  const desktop = window.matchMedia('(min-width: 990px)').matches;
  const io = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) { load(); io.disconnect(); }
  }, { root: desktop && pw ? pw : null, rootMargin: '800px 0px' });
  io.observe(track);
}

function initMain(root) {
  if (root.dataset.sbReady) return;
  root.dataset.sbReady = '1';
  const gallery = initGallery(root, readJSON($(root, '[data-sb-config]')) || {});
  initBuy(root, gallery);
  initFit(root);
  $$(root, '[data-sb-delivery]').forEach(initDelivery);
}

function initAll(scope = document) {
  $$(scope, '[data-sb-main]').forEach(initMain);
  $$(scope, '[data-sb-acc-list]').forEach(initAccordion);
  $$(scope, '[data-sb-reviews]').forEach(initReviews);
  $$(scope, '.sb-ugc__track').forEach(initUgc);
  if (scope !== document && scope.matches) {
    if (scope.matches('[data-sb-main]')) initMain(scope);
    if (scope.matches('[data-sb-reviews]')) initReviews(scope);
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
else initAll();
document.addEventListener('shopify:section:load', (e) => initAll(e.target || document));